export default {
    isWebcast(transmission_type_id) {
        return transmission_type_id === 8
    }
}